import React, { ComponentProps } from 'react'

import { pxToRem } from '@/shared/styles/themes'
import { faClose } from '@fortawesome/pro-regular-svg-icons/faClose'
import { Alert, AlertTitle, Snackbar as MuiSnackBar, styled, Typography } from '@mui/material'

import { Icon } from '../Icon/Icon'
import { IconButton } from '../IconButton/IconButton'

export type ToastContent = {
  open: boolean
  title: string
  content: string
  severity: 'success' | 'error' | 'warning' | 'info'
}

export type ToastProps = Omit<ComponentProps<typeof MuiSnackBar>, 'anchorOrigin' | 'message' | 'open'> & ToastContent

// const SlideTransition: React.FC<SlideProps> = (props) => {
//   return <Slide {...props} direction={props.in ? 'up' : 'left'} />
// }


export const Toast: React.FC<ToastProps> = ({ title, content, severity, children, ...props }) => {
  return (
    <StyledMuiSnackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      autoHideDuration={2000}
      {...props}
    >
      <StyledAlert
        severity={severity}
        action={
          <IconButton
            round
            aria-label="close"
            size="small"
            onClick={(ev) => props?.onClose && props.onClose(ev, 'clickaway')}
          >
            <Icon icon={faClose} fontSize="inherit" />
          </IconButton>
        }
      >
        <AlertTitle>{title}</AlertTitle>
        <div dangerouslySetInnerHTML={{ __html: content }}></div>
        {children}
      </StyledAlert>
    </StyledMuiSnackbar>
  )
}

export const StyledMuiSnackbar = styled(MuiSnackBar)`
  max-height: ${pxToRem(64)};
`

export const StyledTitle = styled(Typography)`
  font-weight: 500;
  font-size: ${({ theme }) => theme.typography.pxToRem(14)};
`

export const StyledContent = styled(Typography)`
  font-size: ${({ theme }) => theme.typography.pxToRem(12)};
`

const StyledAlert = styled(Alert)`
  max-width: ${({ theme }) => theme.typography.pxToRem(400)};
`